import React from "react";
import { Facebook, Youtube, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socials = [
    {
      icon: <Facebook className="w-5 h-5" />,
      link: "https://www.facebook.com/people/National-Property-Consultant/100087385264664/",
      label: "Facebook",
    },
    {
      icon: <Youtube className="w-5 h-5" />,
      link: "https://www.youtube.com/channel/UCcS1Ux050PkE8VhZCZoCCNQ",
      label: "YouTube",
    },
    {
      icon: <Instagram className="w-5 h-5" />,
      link: "https://www.instagram.com/nationalpropertyconsultant/",
      label: "Instagram",
    },
  ];

  return (
    <footer className="bg-[#003366] text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Logo + Tagline */}
        <div className="space-y-4">
          <img src="/NPC.png" alt="NPC Logo" className="h-12 w-auto" />
          <p className="text-sm text-white/80">Buy Smarter. Grow Faster.</p>
          <div className="flex gap-4 mt-2">
            {socials.map((s, idx) => (
              <a
                key={idx}
                href={s.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="text-white/80 hover:text-[#fbb40b] transition"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-bold mb-4 text-[#fbb40b] text-base">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li><Link to="/" className="hover:text-[#fbb40b]">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#fbb40b]">About Us</Link></li>
            <li><Link to="/case-studies" className="hover:text-[#fbb40b]">Case Studies</Link></li>
            <li><Link to="/contact" className="hover:text-[#fbb40b]">Contact</Link></li>
            <li><Link to="/about#faq" className="hover:text-[#fbb40b]">FAQ</Link></li>
            {/* <li><Link to="/privacy-policy" className="hover:text-[#fbb40b]">Privacy Policy</Link></li> */}
          </ul>
        </div>

        {/* Expertise */}
        <div>
          <h4 className="font-bold mb-4 text-[#fbb40b] text-base">Our Expertise</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li>End-to-End Service</li>
            <li>Strategy Development</li>
            <li>Investment Property</li>
            <li>Property Search</li>
            <li>Auction Bidding</li>
          </ul>
        </div>

        {/* Locations */}
        <div>
          <h4 className="font-bold mb-4 text-[#fbb40b] text-base">Where We Help</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li>Adelaide</li>
            <li>Melbourne</li>
            <li>Sydney</li>
            <li>Brisbane</li>
            <li>Perth</li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-bold mb-4 text-[#fbb40b] text-base">Contact Us</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li>
              <a href="tel:0420682960" className="hover:text-[#fbb40b] transition">
                📞 0420 682 960
              </a>
            </li>
            <li>
              <a href="mailto:info@nationalpropertyconsultant.com.au" className="hover:text-[#fbb40b] transition">
                info@nationalpropertyconsultant.com.au
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-12 text-center text-sm text-white border-t border-white/20 pt-6">
        <p>© {currentYear} National Property Consultant. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
